const tablePage = {
  data () {
    return {
      recTot: 0,
      requestParams: {
        page: 1,
        page_size: 40
      },
      list: [],
      actionShow: false,
      containerH: 500
    }
  },
  methods: {
    selectChange (select) {
      if (select.length) {
        this.actionShow = true
      } else {
        this.actionShow = false
      }
      this.checkbox = []
      for (let i = 0; i < select.length; i++) {
        this.checkbox.push(select[i].id)
      }
    }
  },
  mounted () {
    this.$getClientHeight()
  }
}
const buttonModal = {
  data () {
    return {
      checkbox: []
    }
  },
  methods: {
    // 删除
    toDel (url, menuCode, ids) {
      if (!ids || !ids.length) {
        this.$Message.error('请选择待删除的记录')
        return
      }
      this.$Modal.confirm({
        title: '注意',
        content: '确定删除吗？',
        onOk: () => {
          this.$setAuth(menuCode)
          this.$axios.post(url, {
            id: ids
          }).then(() => {
            this.getList()
            this.$Message.success('删除成功')
          })
        }
      })
    },
    delOne (url, menuCode, id) {
      this.$Modal.confirm({
        title: '注意',
        content: '确定删除吗？',
        onOk: () => {
          this.$setAuth(menuCode)
          this.$axios.post(url, {
            id: id
          }).then(() => {
            this.start()
            this.$Message.success('删除成功')
          })
        }
      })
    }
  }
}
const frame = {
  data () {
    return {
      checkbox: [],
      actionShow: false,
      tableData1: [],
      list: []
    }
  },
  methods: {
    exp (url, menuCode, cond) {
      this.$setAuth(menuCode)
      this.$getDownloadUrl(url, cond)
    },
    expV2 (url, menuCode, cond) {
      this.$setAuth(menuCode)
      this.$getDownloadUrl2(url, cond)
    },
    search () {
      this.getList()
    },
    reset () {
      this.form = this.$setDataNull(this.form)
      this.getList()
    },
    // 删除
    del (url, menuCode) {
      if (!this.checkbox.length) {
        this.$Message.error('请选择待删除的记录')
        return
      }
      this.$Modal.confirm({
        title: '注意',
        content: '确定删除吗？',
        onOk: () => {
          this.$setAuth(menuCode)
          this.$axios.post(url, { id: this.checkbox }).then(() => {
            this.getList()
            if (!this.tableData1.length || !this.list.length) {
              this.actionShow = false
            }
            this.$Message.success('删除成功')
          })
        }
      })
    },
    delOne (url, menuCode, id) {
      this.$Modal.confirm({
        title: '注意',
        content: '确定删除吗？',
        onOk: () => {
          this.$setAuth(menuCode)
          this.$axios.post(url, { id: id }).then(() => {
            this.start()
            this.$Message.success('删除成功')
          })
        }
      })
    },
    cancelOne (url, menuCode, id) {
      this.$Modal.confirm({
        title: '注意',
        content: '确定作废吗？',
        onOk: () => {
          this.$setAuth(menuCode)
          this.$axios.post(url, { id: id }).then(() => {
            this.start()
            this.$Message.success('作废成功')
          })
        }
      })
    },
    dealSelect (url, menuCode, title, id) {
      this.$Modal.confirm({
        title: '注意',
        content: '确定' + title + '吗？',
        onOk: () => {
          this.$setAuth(menuCode)
          this.$axios.post(url, { id: id !== undefined ? id : this.checkbox }).then(() => {
            this.start()
            this.$Message.success('操作成功')
          })
        }
      })
    },
    // 前台分页
    filterList (listStr, filterForm) {
      let list = JSON.parse(listStr)
      let filters = {}
      let form = filterForm
      let keysF = Object.keys(form)
      keysF.forEach(function (key) {
        if (form[key] !== '' && form[key] !== null && form[key] !== undefined) {
          filters[key] = form[key]
        }
      })
      let keys = Object.keys(filters)
      let result = list.filter(item => {
        return keys.every(key => {
          if (typeof filters[key] === 'object') {
            if (filters[key][0] === '') {
              return Number(item[key]) <= Number(filters[key][1])
            } else if (filters[key][1] === '') {
              return Number(item[key]) >= Number(filters[key][0])
            } else {
              return Number(item[key]) >= Number(filters[key][0]) && Number(item[key]) <= Number(filters[key][1])
            }
          } else {
            return String(item[key]).indexOf(filters[key]) > -1
          }
        })
      })
      return result
    }
  }
}

const filterCard = {
  data () {
    return {
      filterCardReset: false,
      show: false,
      custom: {},
      key: '', // 当前点击列 - key
      filteredList: [], // 存放筛选 key
      copyFilterdList: [],
      filterType: {
        'select': { type: 'select', opt_type: 'str_in' },
        'date_range': { type: 'date', opt_type: 'date_range' },
        'date_time': { type: 'time', opt_type: 'date_range' },
        'input': { type: 'text', opt_type: 'like' },
        'eq': { type: 'text', opt_type: 'eq' },
        'number': { type: 'number', opt_type: 'float_range' }
      }
    }
  },
  methods: {
    closeEven () {
      this.show = false
    },
    isHasValue (val) {
      if (val !== undefined && val !== null && val !== '') {
        return true
      } else {
        return false
      }
    },
    fontFilter () {
      let arr = [...this.list]
      for (let item of this.copyFilterdList) {
        let type = item.type
        let value = item.value
        if (type === 'number') {
          if (value[0] && value[1]) {
            arr = arr.filter(x => this.getNumber(x[item.field]) >= +value[0] && this.getNumber(x[item.field]) <= +value[1])
          } else if (value[0]) {
            arr = arr.filter(x => this.getNumber(x[item.field]) >= +value[0])
          } else if (value[1]) {
            arr = arr.filter(x => this.getNumber(x[item.field]) <= +value[1])
          }
        } else if (type === 'text') {
          arr = arr.filter(x => String(x[item.field]).includes(value))
        } else if (type === 'select') {
          for (let val of value) {
            arr = arr.filter(x => x[item.field] === val)
          }
        } else if (type === 'date') {
          if (value[0] && value[1]) {
            arr = arr.filter(x => new Date(x[item.field]).getTime() >= new Date(value[0]).getTime() && new Date(x[item.field]) <= new Date(value[1]).getTime())
          }
        }
      }
      this.tableFilterList = arr
    },
    getNumber (str) {
      if (!str) return 0
      if (isNaN(parseFloat(str))) {
        return this.$strToNum(str[0], str.slice(1))
      }
      return str
    },
    setColumns (column, leftDistance = 0, rightDistance = 0) {
      for (let i = 0; i < column.length; i++) {
        let renderHeader
        if (column[i].filter_type && !column[i].renderHeader) {
          renderHeader = (h, params) => {
            return h('div', {
              style: {
                display: 'inline'
              }
            }, [
              h('span', params.column.title),
              h('Icon', {
                style: {
                  marginLeft: '5px'
                },
                props: {
                  type: 'ios-funnel',
                  color: (() => {
                    if (this.filteredList.length) {
                      let arr = []
                      let optType = []
                      for (let item of this.filteredList) {
                        arr.push(item.field)
                        optType.push(item.opt_type)
                      }
                      let bool = arr.includes(column[i].key) && optType.includes(this.filterType[column[i].filter_type].opt_type)
                      let obj = this.filteredList.filter(x => x.field === column[i].key && x.opt_type === this.filterType[column[i].filter_type].opt_type)[0]
                      if (obj) {
                        if (!obj.value.length) return '#c5c8ce'
                        if (obj.value.length > 1) {
                          if (obj.value[0] || obj.value[1]) {
                            bool = true
                          } else {
                            bool = false
                          }
                        } else {
                          if (!obj.value[0]) {
                            bool = false
                            return '#c5c8ce'
                          }
                        }
                      }
                      return bool ? '#2d8cf0' : '#c5c8ce'
                    } else {
                      return '#c5c8ce'
                    }
                  })()
                },
                on: {
                  click: (e) => {
                    console.log(e)
                    if (this.key !== params.column.key) {
                      this.key = params.column.key
                      this.$set(this.custom, 'value', '')
                    }
                    e.stopPropagation()
                    this.show = true
                    // if (el) container = el.getBoundingClientRect()
                    let a = e.target.getBoundingClientRect()
                    let diff = document.body.clientWidth - a.x
                    let style = {
                      position: 'absolute',
                      top: this.$refs.table.headerHeight + 'px'
                    }
                    let clientWidth = document.body.clientWidth
                    if (diff > 300) {
                      style = Object.assign(style, {
                        left: a.x - leftDistance + 'px'
                      })
                    } else {
                      style = Object.assign(style, {
                        right: clientWidth - a.right - rightDistance + 'px'
                      })
                    }
                    let obj = column[i]
                    this.$set(this.custom, 'style', style)
                    this.$set(this.custom, 'value', obj._filterVal)
                    if (obj.filter_type) {
                      this.$set(this.custom, 'opt_type', this.filterType[obj.filter_type].opt_type)
                      this.$set(this.custom, 'type', this.filterType[obj.filter_type].type)
                      this.$set(this.custom, 'fuzzy_search', obj.fuzzy_search || false)
                    }
                    this.$set(this.custom, 'field', obj.key)
                    if (obj.filter_type && obj.options) {
                      this.$set(this.custom, 'options', obj.options)
                    }
                  }
                }
              })
            ]
            )
          }
        } else {
          renderHeader = (h, params) => {
            return h('div', [h('span', params.column.title)])
          }
        }
        if (column[i].filter_type && !column[i].renderHeader) {
          this.$set(column[i], 'renderHeader', renderHeader)
        }
      }
    },
    handleEven (obj, column) {
      let filterObj = column.filter(x => x.key === obj.field)[0]
      filterObj._filterVal = obj.value
      filterObj._isFiltered = obj.value && obj.value.length > 0
      this.$set(this.custom, '_isFiltered', filterObj._isFiltered)
      this.$set(this.custom, 'value', obj.value)
      let index = this.filteredList.findIndex(m => {
        return (m && m.field) === obj.field
      })
      let value = obj.value
      if (obj.type === 'number' || obj.type === 'date' || obj.type === 'time') {
        let string0 = this.isHasValue(obj.value[0]) ? String(obj.value[0]) : ''
        let string1 = this.isHasValue(obj.value[1]) ? String(obj.value[1]) : ''
        value = [string0, string1]
      } else if (obj.type === 'text') {
        value = [obj.value]
      }
      let condobj = {
        field: obj.field,
        opt_type: obj.opt_type,
        value: value
      }
      if (index > -1) {
        this.filteredList.splice(index, 1, condobj)
        this.copyFilterdList.splice(index, 1, Object.assign({ type: obj.type }, condobj))
      } else {
        this.filteredList.push(condobj)
        this.copyFilterdList.push(Object.assign({ type: obj.type }, condobj))
      }
      this.currentPage = 1
    }
  }
}

const getType = {
  created () {
    this.getTypeOptions(this.columns)
  },
  methods: {
    getTypeOptions (columns) {
      this.$axios.post(this.$URLS.getPartTypeDict).then(({ data: { list } }) => {
        if (this.$notNull(list)) {
          for (let i in columns) {
            if (columns[i].filter && columns[i].key === 'type') {
              this.$set(columns[i].filter, 'options', list)
            }
          }
        }
      })
    }
  }
}
export {
  frame, filterCard, getType, tablePage, buttonModal
}



// WEBPACK FOOTER //
// ./src/assets/mixins/frame.js